import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { grantsForScope } from "../rbac/grantQueries";
import { assertNotPersonal } from "../spaceName";
import { mutator } from "./mutator";

export const deleteSpace = mutator({
  schema: z.object({ spaceId: z.string() }),
  resolve: {
    space: { kind: "space", from: "spaceId" },
  },
  permissions: [
    {
      permission: "space:manage",
      scopeId: ({ args }) => args.space.id,
    },
  ],
  fn: async ({ tx, args: { space } }) => {
    assertNotPersonal(space, "delete");

    const [workflow] = await tx.run(
      zql.workflows
        .where("spaceId", space.id)
        .where("deletedAt", "IS", null)
        .limit(1)
    );
    if (workflow) {
      throw userFacingError(
        "Move or delete all workflows before deleting this space"
      );
    }

    const grants = await tx.run(grantsForScope(space.id, space.tenantId));
    for (const g of grants) {
      await tx.mutate.roleGrants.delete({ id: g.id });
    }

    const stalePrefs = await tx.run(
      zql.userPreferences
        .where("tenantId", space.tenantId)
        .where(({ or, cmp }) =>
          or(cmp("defaultSpace", space.id), cmp("defaultHome", space.id))
        )
    );
    for (const pref of stalePrefs) {
      await tx.mutate.userPreferences.update({
        userId: pref.userId,
        defaultSpace: pref.defaultSpace === space.id ? null : pref.defaultSpace,
        defaultHome: pref.defaultHome === space.id ? null : pref.defaultHome,
      });
    }

    await tx.mutate.spaces.delete({ id: space.id });
  },
});
